var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-uploader',{attrs:{"after-read":_vm.afterRead}},[_c('van-cell',{attrs:{"is-link":"","border":false},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"header-span-name"},[_vm._v("头像")])]},proxy:true}])},[_c('img',{staticClass:"header-img",attrs:{"src":_vm.userInfo.fileKey}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }